/*
 * Copyright (c) 2026. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

import { createContext, type Dispatch, useContext } from 'react';
import type { AgentSessionStore, AgentSessionStoreAction } from './components/agentSessionStore';

export interface AgentSessionContextValue {
  dispatchSessionAction: Dispatch<AgentSessionStoreAction>;
  sessionStore: AgentSessionStore;
}

export const AgentSessionContext = createContext<AgentSessionContextValue | undefined>(undefined);

export const useOptionalAgentSession = () => useContext(AgentSessionContext);
